import React from 'react';
import ModalForm from '#app/components/ModalForm/ModalForm';
import { Body, BodyBold, Title2, Title3 } from '#app/components/Text/styles';

function AgreementModalContent() {
  return (
    <div style={{ overflow: 'auto', maxHeight: '70vh', textAlign: 'left' }}>
      <Title2>Пользовательское Соглашение</Title2>
      <br />
      <br />
      <Title3>1. ОБЩИЕ ПОЛОЖЕНИЯ</Title3>
      <br />
      <Body left>
        1.1. Настоящее Пользовательское соглашение (далее по тексту – Соглашение) относится к
        целевой аудитории сайта whiteswan (белый лебедь), расположенному по адресу
        https://whiteswan.finance/ (далее по тексту — Сайт), и ко всем соответствующим сайтам,
        связанным с Сайтом.
      </Body>
      <Body left>
        1.2. Настоящее Соглашение регулирует отношения между Администрацией сайта whiteswan (далее
        по тексту – Администрация сайта) и Пользователем данного Сайта (далее по тексту —
        Пользователь).
      </Body>
      <Body left>
        1.3. Администрация сайта оставляет за собой право в любое время изменять, добавлять или
        удалять пункты настоящего Соглашения без уведомления Пользователя.
      </Body>
      <Body left>
        1.4. Продолжение использования Сайта Пользователем означает принятие Соглашения и изменений,
        внесенных в настоящее Соглашение.
      </Body>
      <Body left>
        1.5. Пользователь несет персональную ответственность за проверку настоящего Соглашения на
        наличие изменений в нем.
      </Body>
      <br />
      <Title3>2. ОПРЕДЕЛЕНИЯ ТЕРМИНОВ</Title3>
      <br />
      <Body left>
        2.1. Перечисленные ниже термины имеют для целей настоящего Соглашения следующее значение:
      </Body>
      <Body left>
        2.1.1 whiteswan (белый лебедь) – сайт, расположенный на доменном имени
        https://whiteswan.finance/, осуществляющий свою деятельность посредством Интернет-ресурса и
        сопутствующих ему сервисов.
      </Body>
      <Body left>
        2.1.2. Администрация сайта – уполномоченные сотрудники на управления Сайтом, действующие от
        имени настоящего ресурса.
      </Body>
      <Body left>
        2.1.3. Пользователь сайта (далее — Пользователь) – лицо, имеющее доступ к Сайту, посредством
        сети Интернет и использующее Сайт.
      </Body>
      <Body left>
        2.1.4. Содержание сайта (далее – Содержание) — охраняемые результаты интеллектуальной
        деятельности, включая тексты литературных произведений, их названия, предисловия, аннотации,
        статьи, иллюстрации, обложки, музыкальные произведения с текстом или без текста,
        графические, текстовые, фотографические, производные, составные и иные произведения,
        пользовательские интерфейсы, визуальные интерфейсы, названия товарных знаков, логотипы,
        программы для ЭВМ, базы данных, а также дизайн, структура, выбор, координация, внешний вид,
        общий стиль и расположение данного Содержания, входящего в состав Сайта и другие объекты
        интеллектуальной собственности все вместе и/или по отдельности, содержащиеся на сайте
        Интернет-магазина.
      </Body>
      <br />
      <Title3>3. ПРЕДМЕТ СОГЛАШЕНИЯ</Title3>
      <br />
      <Body left>
        3.1. Предметом настоящего Соглашения является предоставление Пользователю доступа к
        содержащейся на сайте информации.
      </Body>
      <Body left>3.1.1. Сайт предоставляет Пользователю следующие виды услуг (сервисов):</Body>
      <Body>
        <ul style={{ textAlign: 'left' }}>
          <li>доступ к электронному контенту, с правом просмотра контента;</li>
          <li>доступ к средствам поиска и навигации;</li>
          <li>
            предоставление Пользователю возможности размещения сообщений, комментариев, рецензий
            Пользователей, выставления оценок контенту сайта;
          </li>
          <li>иные виды услуг (сервисов), реализуемые на страницах сайта.</li>
        </ul>
      </Body>
      <Body left>
        3.1.2. Под действие настоящего Соглашения подпадают все существующие (реально
        функционирующие) на данный момент услуги (сервисы) сайта, а также любые их последующие
        модификации и появляющиеся в дальнейшем дополнительные услуги (сервисы).
      </Body>
      <Body left>3.2. Доступ к сайту предоставляется на бесплатной основе.</Body>
      <Body left>
        3.3. Настоящее Соглашение является публичной офертой. Получая доступ к Сайту, Пользователь
        считается присоединившимся к настоящему Соглашению.
      </Body>
      <Body left>
        3.4. Использование материалов и сервисов Сайта регулируется нормами действующего
        законодательства Российской Федерации.
      </Body>
      <br />
      <Title3>4. ПРАВА И ОБЯЗАННОСТИ СТОРОН</Title3>
      <br />
      <BodyBold>4.1. Администрация сайта вправе: </BodyBold>
      <Body left>
        4.1.1. Изменять правила пользования Сайтом, а также изменять содержание данного Сайта.
        Изменения вступают в силу с момента публикации новой редакции Соглашения на Сайте.
      </Body>
      <Body left>
        4.1.2. Ограничить доступ к Сайту в случае нарушения Пользователем условий настоящего
        Соглашения.
      </Body>
      <BodyBold>4.2. Пользователь вправе: </BodyBold>
      <Body left>4.2.1. Пользоваться всеми имеющимися на Сайте услугами.</Body>
      <Body left>4.2.2. Задавать любые вопросы, относящиеся к услугам.</Body>
      <Body left>
        4.2.3. Пользоваться Сайтом исключительно в целях и порядке, предусмотренных Соглашением и не
        запрещенных законодательством Российской Федерации.
      </Body>
      <BodyBold>4.3. Пользователь Сайта обязуется: </BodyBold>
      <Body left>
        4.3.1. Предоставлять по запросу Администрации сайта дополнительную информацию, которая имеет
        непосредственное отношение к предоставляемым услугам данного Сайта.
      </Body>
      <Body left>
        4.3.2. Соблюдать имущественные и неимущественные права авторов и иных правообладателей при
        использовании Сайта.
      </Body>
      <Body left>
        4.3.3. Не предпринимать действий, которые могут рассматриваться как нарушающие нормальную
        работу Сайта.
      </Body>
      <Body left>
        4.3.4. Не распространять с использованием Сайта любую конфиденциальную и охраняемую
        законодательством Российской Федерации информацию о физических либо юридических лицах.
      </Body>
      <Body left>
        4.3.5. Избегать любых действий, в результате которых может быть нарушена конфиденциальность
        охраняемой законодательством Российской Федерации информации.
      </Body>
      <Body left>
        4.3.6. Не использовать Сайт для распространения информации рекламного характера, иначе как с
        согласия Администрации сайта.
      </Body>
      <Body left>4.3.7. Не использовать сервисы сайта с целью:</Body>
      <Body left>
        4.3.7.1. загрузки контента, который является незаконным, нарушает любые права третьих лиц;
        пропагандирует насилие, жестокость, ненависть и (или) дискриминацию по расовому,
        национальному, половому, религиозному, социальному признакам; содержит недостоверные
        сведения и (или) оскорбления в адрес конкретных лиц, организаций, органов власти;
      </Body>
      <Body left>
        4.3.7.2. побуждения к совершению противоправных действий, а также содействия лицам, действия
        которых направлены на нарушение ограничений и запретов, действующих на территории Российской
        Федерации;
      </Body>
      <Body left>
        4.3.7.3. нарушения прав несовершеннолетних лиц и (или) причинение им вреда в любой форме;
      </Body>
      <Body left>4.3.7.4. ущемления прав меньшинств;</Body>
      <Body left>
        4.3.7.5. представления себя за другого человека или представителя организации и (или)
        сообщества без достаточных на то прав, в том числе за сотрудников данного сайта.
      </Body>
      <BodyBold>4.4. Пользователю запрещается: </BodyBold>
      <Body left>
        4.4.1. Использовать любые устройства, программы, процедуры, алгоритмы и методы,
        автоматические устройства или эквивалентные ручные процессы для доступа, приобретения,
        копирования или отслеживания содержания Сайта.
      </Body>
      <Body left>4.4.2. Нарушать надлежащее функционирование Сайта.</Body>
      <Body left>
        4.4.3. Любым способом обходить навигационную структуру Сайта для получения или попытки
        получения любой информации, документов или материалов любыми средствами, которые специально
        не представлены сервисами данного Сайта.
      </Body>
      <Body left>
        4.4.4. Несанкционированный доступ к функциям Сайта, любым другим системам или сетям,
        относящимся к данному Сайту, а также к любым услугам, предлагаемым на Сайте.
      </Body>
      <Body left>
        4.4.5. Нарушать систему безопасности или аутентификации на Сайте или в любой сети,
        относящейся к Сайту.
      </Body>
      <Body left>
        4.4.6. Выполнять обратный поиск, отслеживать или пытаться отслеживать любую информацию о
        любом другом Пользователе Сайта.
      </Body>
      <Body left>
        4.4.7. Использовать Сайт и его Содержание в любых целях, запрещенных законодательством
        Российской Федерации, а также подстрекать к любой незаконной деятельности или другой
        деятельности, нарушающей права Сайта или других лиц.
      </Body>
      <br />
      <Title3>5. ИСПОЛЬЗОВАНИЕ САЙТА</Title3>
      <br />
      <Body left>
        5.1. Сайт и Содержание, входящее в состав Сайта, принадлежит и управляется Администрацией
        сайта.
      </Body>
      <Body left>
        5.2. Содержание Сайта не может быть скопировано, опубликовано, воспроизведено, передано или
        распространено любым способом, а также размещено в глобальной сети «Интернет» без
        предварительного письменного согласия Администрации сайта.
      </Body>
      <Body left>
        5.3. Содержание Сайта защищено авторским правом, законодательством о товарных знаках, а
        также другими правами, связанными с интеллектуальной собственностью, и законодательством о
        недобросовестной конкуренции.
      </Body>
      <Body left>
        5.4. Некоторые действия, могут потребовать создания учётной записи Пользователя.
      </Body>
      <Body left>
        5.5. Пользователь несет персональную ответственность за сохранение конфиденциальности
        информации учётной записи, включая пароль, а также за всю без исключения деятельность,
        которая ведётся от имени Пользователя учётной записи.
      </Body>
      <Body left>
        5.6. Пользователь должен незамедлительно уведомить Администрацию сайта о несанкционированном
        использовании его учётной записи или пароля или любом другом нарушении системы безопасности.
      </Body>
      <Body left>
        5.7. Администрация сайта обладает правом в одностороннем порядке аннулировать учетную запись
        Пользователя, если она не использовалась более 6 месяцев календарных месяцев подряд без
        уведомления Пользователя.
      </Body>
      <Body left>
        5.8. Настоящее Соглашение распространяет свое действия на все дополнительные положения и
        условия о покупке Товара и оказанию услуг, предоставляемых на Сайте.
      </Body>
      <Body left>
        5.9. Информация, размещаемая на Сайте, не должна истолковываться как изменение настоящего
        Соглашения.
      </Body>
      <Body left>
        5.10. Администрация сайта имеет право в любое время без уведомления Пользователя вносить
        изменения.
      </Body>
      <Body left>
        5.11. Документы, указанные в пункте 5.11.1 настоящего Соглашения, регулируют в
        соответствующей части и распространяют свое действие на использование Пользователем Сайта. В
        настоящее Соглашение включены следующие документы:
      </Body>
      <Body left>5.11.1. Политика конфиденциальности.</Body>
      <Body left>
        5.12. Любой из документов, перечисленных в пункте 5.11 настоящего Соглашения, может
        подлежать обновлению. Изменения вступают в силу с момента их опубликования на Сайте.
      </Body>
      <br />
      <Title3>6. ОТВЕТСТВЕННОСТЬ</Title3>
      <br />
      <Body left>
        6.1. Любые убытки, которые Пользователь может понести в случае умышленного или неосторожного
        нарушения любого положения настоящего Соглашения, а также вследствие несанкционированного
        доступа к коммуникациям другого Пользователя, Администрацией сайта не возмещаются.
      </Body>
      <Body left>6.2. Администрация сайта не несет ответственности за:</Body>
      <Body left>
        6.2.1. Задержки или сбои в процессе совершения операции, возникшие вследствие непреодолимой
        силы, а также любого случая неполадок в телекоммуникационных, компьютерных, электрических и
        иных смежных системах.
      </Body>
      <Body left>
        6.2.2. Действия систем переводов, банков, платежных систем и за задержки, связанные с их
        работой.
      </Body>
      <Body left>
        6.2.3. Надлежащее функционирование Сайта в случае, если Пользователь не имеет необходимых
        технических средств для его использования, а также не несет никаких обязательств по
        обеспечению пользователей такими средствами.
      </Body>
      <br />
      <Title3>7. НАРУШЕНИЕ УСЛОВИЙ ПОЛЬЗОВАТЕЛЬСКОГО СОГЛАШЕНИЯ</Title3>
      <br />
      <Body left>
        7.1. Администрация сайта вправе раскрыть любую собранную о Пользователе данного Сайта
        информацию, если раскрытие необходимо в связи с расследованием или жалобой в отношении
        неправомерного использования Сайта либо для установления (идентификации) Пользователя,
        который может нарушать или вмешиваться в права Администрации сайта или в права других
        Пользователей Сайта.
      </Body>
      <Body left>
        7.2. Администрация сайта имеет право раскрыть любую информацию о Пользователе, которую
        посчитает необходимой для выполнения положений действующего законодательства или судебных
        решений, обеспечения выполнения условий настоящего Соглашения, защиты прав или безопасности
        Сайта, других Пользователей.
      </Body>
      <Body left>
        7.3. Администрация сайта имеет право раскрыть информацию о Пользователе, если действующее
        законодательство Российской Федерации требует или разрешает такое раскрытие.
      </Body>
      <Body left>
        7.4. Администрация сайта вправе без предварительного уведомления Пользователя прекратить и
        (или) заблокировать доступ к Сайту, если Пользователь нарушил настоящее Соглашение или
        содержащиеся в иных документах условия пользования Сайтом, а также в случае прекращения
        действия Сайта либо по причине технической неполадки или проблемы.
      </Body>
      <Body left>
        7.5. Администрация сайта не несет ответственности перед Пользователем или третьими лицами за
        прекращение доступа к Сайту в случае нарушения Пользователем любого положения настоящего
        Соглашения или иного документа, содержащего условия пользования Сайтом.
      </Body>
      <br />
      <Title3>8. РАЗРЕШЕНИЕ СПОРОВ</Title3>
      <br />
      <Body left>
        8.1. В случае возникновения любых разногласий или споров между Сторонами настоящего
        Соглашения обязательным условием до обращения в суд является предъявление претензии
        (письменного предложения о добровольном урегулировании спора).
      </Body>
      <Body left>
        8.2. Получатель претензии в течение 30 календарных дней со дня ее получения, письменно
        уведомляет заявителя претензии о результатах рассмотрения претензии.
      </Body>
      <Body left>
        8.3. При невозможности разрешить спор в добровольном порядке, любая из Сторон вправе
        обратиться в суд за защитой своих прав, которые предоставлены им законодательством
        Российской Федерации.
      </Body>
      <Body left>
        8.4. Любой иск в отношении условий использования Сайта должен быть предъявлен в течение трех
        лет после возникновения оснований для иска, за исключением защиты авторских прав на
        охраняемые в соответствии с законодательством материалы Сайта. При нарушении условий данного
        пункта любой иск или основания для иска погашаются исковой давностью.
      </Body>
      <br />
      <Title3>9. ДОПОЛНИТЕЛЬНЫЕ УСЛОВИЯ</Title3>
      <br />
      <Body left>
        9.1. Администрация сайта не принимает встречные предложения от Пользователя относительно
        изменений настоящего Пользовательского соглашения.
      </Body>
      <Body left>
        9.2. Отзывы Пользователя, размещенные на Сайте, не являются конфиденциальной информацией и
        могут быть использованы Администрацией сайта без ограничений.
      </Body>
    </div>
  );
}

/** Окно для незалогиненных: только показ текста, без Redux и client. */
const AgreementModal = ({ show, onClose }) => (
  <ModalForm modalVisible={!!show} closeForm={onClose} header="Пользовательское Соглашение">
    <AgreementModalContent />
  </ModalForm>
);

export default AgreementModal;
